import { OrderedColumnsT, TimeScales } from 'business/definitions';
import { capitalize } from 'helpers/helpers';
import { camelize } from 'helpers/syntaxHelper';
import { translateBlock, translateComponent } from 'i18n';

export const X_AXIS_DIMENSION = 'xAxis';
export const Y_AXIS_DIMENSION = 'yAxis';
/** Get the sort dimension setting input options according to the request and the chart conception.
 * @param {ExploreMetricT[]} sentenceMetrics - the request metrics
 * @param {OrderedColumnsT | undefined} chartDimensions - the chart dimensions
 * @param {boolean} isHorizontal - true if the chart is an horizontal bar chart
 * @returns {{label: string, value: string}[]}}
 */
export const getSortDimensionOptions = (
    sentenceMetrics: ExploreMetricT[],
    chartDimensions: OrderedColumnsT | undefined,
    isHorizontal: boolean,
) => {
    const baseOptions = [
        {
            label: capitalize(translateComponent('default')),
            value: '',
        },
    ];

    if (chartDimensions) {
        const isMonoMetric = sentenceMetrics.length === 1;
        const sentenceMetric = sentenceMetrics[0];
        baseOptions.push({
            value: Y_AXIS_DIMENSION,
            label: isMonoMetric
                ? capitalize(translateBlock(camelize(sentenceMetric.field)))
                : translateComponent(
                      isHorizontal
                          ? 'chartSettings.xAxis'
                          : 'chartSettings.yAxis',
                  ),
        });

        if (chartDimensions.x && chartDimensions.x.scale !== TimeScales.dow) {
            const multipleColumns =
                chartDimensions.x.mergedColumns &&
                chartDimensions.x.mergedColumns.length > 1;
            return [
                ...baseOptions,
                {
                    label: multipleColumns
                        ? translateComponent(
                              isHorizontal
                                  ? 'chartSettings.yAxis'
                                  : 'chartSettings.xAxis',
                          )
                        : capitalize(chartDimensions.x.label),
                    value: X_AXIS_DIMENSION,
                },
            ];
        }
    }
    return baseOptions;
};
